import angular           from 'angular'

import DeleteVehicle from './delete-vehicle'
import EditVehicle   from './edit-vehicle'

let module = angular.module('myGarageComponentsModule', [
  DeleteVehicle,
  EditVehicle
])
.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-garage/components/index.js